<script setup>
import { computed } from 'vue';

import { CsButton } from '../button';
import {
  CsModal,
  CsModalContent,
  CsModalFooter,
  CsModalHeader,
} from '../modal';
import { CsText } from '../text';

import { useDialogConfirmation } from './useDialogConfirmation';

const { isLoading, state, close, handleOnCancel, handleOnConfirm } =
  useDialogConfirmation();

const containsHtml = computed(() => {
  if (!state.message) return false;
  return /<[^>]+>/.test(state.message);
});
</script>

<template>
  <CsModal size="md" :is-open="state.isOpen" @close="close">
    <CsModalHeader>
      {{ state.title }}
    </CsModalHeader>

    <CsModalContent>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <CsText v-if="containsHtml" v-html="state.message" />
      <CsText v-else>{{ state.message }}</CsText>
    </CsModalContent>

    <CsModalFooter>
      <CsButton :is-disabled="isLoading" @click="handleOnCancel">
        {{ state.cancelText }}
      </CsButton>
      <CsButton
        :variant="state.confirmVariant"
        :is-loading="isLoading"
        @click="handleOnConfirm"
      >
        {{ state.confirmText }}
      </CsButton>
    </CsModalFooter>
  </CsModal>
</template>
